import {LeasingTargetGroup} from '../../api/types/onlineOfferTypes';

const TARGET_GROUP_LABEL_KEYS: Record<LeasingTargetGroup, string> = {
  PRIVATE: 'financialProducts.targetGroup.private',
  COMMERCIAL: 'financialProducts.targetGroup.commercial',
};

export const getLeasingTargetGroupLabelKey = (targetGroup: LeasingTargetGroup) =>
  TARGET_GROUP_LABEL_KEYS[targetGroup];
